import React, { useState, useEffect, useMemo, useContext } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link } from "react-router-dom";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import config from "../../../config/config";
import axios from "axios";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import Select from "react-select";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import { Trash2 } from "feather-icons-react/build/IconComponents";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Cell } from "jspdf-autotable";
import moment from "moment";

function PromotionPrice() {
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const Location = localStorage.getItem("Location");

  const [loading, setLoading] = useState(false);

  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [data, setData] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [categoryUpsert, setCategoryUpsert] = useState("");
  const [promotionCategoryType, setPromotionCategoryType] = useState(0);
  const [isProtalPromotion, setIsProtalPromotion] = useState(1);
  const [isEcomPromotion, setIsEcomPromotion] = useState(1);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [toggle, setToggle] = useState("%"); // Initial toggle state
  const [value, setValue] = useState("");
  const [promotionType, setPromotionType] = useState(1);

  const [showItemList, setShowItemList] = useState([]);

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  //   ID,Name,Costprice,Unitprice,Promoprice,Startdate,Enddate,CategoryId
  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      // size: 30,
    },
    {
      header: "Name",
      accessorKey: "Name",
      // size: 90,
    },
    {
      header: "Category",
      accessorKey: "Categoryfullpath",
      // size: 40,
    },
    {
      header: "Cost Price",
      accessorKey: "Costprice",
      // size: 40,
    },
    // {
    //   header: "Cost Price",
    //   accessorKey: "Costprice",
    //   size: 40,
    //   Cell: ({ row }) => {
    //     return (
    //       <div>
    //         {CurrencySymbols(
    //           Number(row.original.Costprice),
    //           { CurrencySymbol },
    //           FractionDigits
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      header: "Unit Price",
      accessorKey: "Unitprice",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.Unitprice), 
              { CurrencySymbol },   
              FractionDigits  
            )}
          </div>
        );
      },
    },
    {
      header: "Item Promo Price",
      accessorKey: "Promoprice",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.Promoprice), 
              { CurrencySymbol },   
              FractionDigits  
            )}
          </div>
        );
      },
    },
    {
      header: "Start Date",
      accessorKey: "Startdate",
      Cell: ({ row }) => (
        <p className="word-break-data">
          {moment(row?.original?.Startdate).format(
            `${dateFormate.toUpperCase()}`
          )}
        </p>
      ),
    },
    {
      header: "End Date",
      accessorKey: "Enddate",
      Cell: ({ row }) => (
        <p className='word-break-data'>
        {moment(row.original?.Enddate).format(`${dateFormate.toUpperCase()}`)}
        </p>
      )
    },
    {
      header: "Apply Promotion Portal",
      accessorKey: "ApplyPromoPortal",
      Cell: ({ row }) => {
        return (
          <div
            style={{
              color: row.original.ApplyPromoPortal == 1 ? "green" : "red",
            }}
          >
            {row.original.ApplyPromoPortal == 1 ? "Applied" : "Not Applied"}
          </div>
        );
      },
    },
    {
      header: "Apply Promotion Ecom",
      accessorKey: "ApplyPromoEcom",
      Cell: ({ row }) => {
        return (
          <div
            style={{
              color: row.original.ApplyPromoEcom == 1 ? "green" : "red",
            }}
          >
            {row.original.ApplyPromoEcom == 1 ? "Applied" : "Not Applied"}
          </div>
        );
      },
    },
    {
      header: "Promo Percentage",
      accessorKey: "PromoPercentage",
      Cell: ({ row }) => {
        return <div>{Number(row.original.PromoPercentage).toFixed(2)}%</div>;
      },
    },
  ]);

  console.log(categoryUpsert, "categoryUpsert");
  const fetchPromotionItemData = () => {
    setLoading(true);

    axios
      .get(
        `${config.priceRulesBaseUrl}/items/promotionitemlist?categoryId=${categoryId}&location=${Location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setLoading(false);
  };

  const fecthCategoryList = () => {
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const CatData = res.data.ResponseData;
        setCategoryList(
          CatData?.map((cat) => {
            return {
              label: cat.Name,
              value: cat.ID,
            };
          })
        );
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPromotionItemData();
  }, [categoryId]);

  useEffect(() => {
    fecthCategoryList();
  }, []);

  const handleChangeCustomStartingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      setCustomStartingDate(selectedDate);
    }
  };

  const handleChangeCustomEndingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      setCustomEndingDate(selectedDate);
    }
  };

  const handleToggleChange = (e) => {
    e.preventDefault();
    setToggle(toggle === "%" ? "$" : "%");
  };

  const handleInputPromoChangeSign = (e) => {
    setValue(e.target.value); // Update input value
  };

  const handleSubmitPromo = (e) => {
    e.preventDefault();

    if (promotionCategoryType === 0 && rowSelectData?.length === 0) {
      toastWarn("Please Select Items");
      return;
    }

    if (promotionCategoryType === 1 && categoryUpsert === "") {
      toastWarn("Please Select Category");
      return;
    }

    if (promotionCategoryType === 2 && showItemList?.length === 0) {
      toastWarn("Please Add items First");
      return;
    }

    // if (isEcomPromotion === 0 && isProtalPromotion === 0) {
    //   toastWarn("Select Fisrt Where You Want To Update E-com or Portal");
    //   return;
    // }

    const PromoData = {
      promotionType: promotionCategoryType === 1 ? 0 : promotionType, // 1 for Turn off Promotion, 2 for Apply and Modify Promotion, 0 for category update from category section
      itemIdsList:
        promotionCategoryType === 0
          ? rowSelectData.join(",")
          : promotionCategoryType === 2
          ? showItemList?.map((e) => e.ItemID).join(",")
          : "",
      // selectedCategory: promotionCategoryType === 0 ? "" : promotionCategoryType === 2 ? '' : categoryUpsert,
      selectedCategory: promotionCategoryType === 1 ? categoryUpsert : "",

      PromoPrice: value,
      Sign: toggle === "%" ? 2 : 1,
      Promostartdate: customStartingDate,
      Promoenddate: customEndingDate,
      isEcom: isEcomPromotion,
      isPoratl: isProtalPromotion,
    };

    console.log(PromoData, "PromoData");
    // return;

    setLoading(true);
    axios
      .post(`${config.categoriesBaseUrl}/categories/PromoUpsert`, PromoData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setIsPopupOpen(false);
          setRowSelectData([]);
          setShowItemList([]);
          setRowSelection({});
          setPromotionType(1);
          setPromotionCategoryType(0);
          setCategoryUpsert("");
          toastSuccess(SUCCESS_MESSAGE);
          setValue("");
          setCustomStartingDate();
          setCustomEndingDate();
          setToggle("%");
          fetchPromotionItemData();
          setIsProtalPromotion(0);
          setIsEcomPromotion(0);
          setLoading(false);
        } else {
          toastError("Something Went Wrong");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error in registration:", error);
        setLoading(false);
      });
  };

  console.log(rowSelectData, "selected Row");
  console.log(categoryId, "categoryId");

  const callback = (payload) => {
    console.log(payload, "payload");

    setShowItemList((prev) => {
      const exists = prev.some((item) => item.ItemID === payload?.ItemID);
      if (!exists) {
        return [
          { ItemID: payload?.ItemID, ItemName: payload?.ItemName },
          ...prev,
        ];
      }
      return prev; // No changes if the item already exists
    });
  };

  const handelRemoveItem = (itemId) => {
    setShowItemList((prev) => [...prev.filter((el) => el.ItemID != itemId)]);
  };
  console.log(showItemList, "showItemList");

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col d-flex"> */}
              {/* <h5 className="page-title">Role Tier</h5> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Promotion Price</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="card-header ">
                <h4 className="card-title mb-0">Promotion Price</h4>
              </div>
              <div className="d-flex gap-2 mb-2">
                <div className="col-md-4">
                  <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    onChange={(e) =>
                      setCategoryId(e.map((cat) => cat.value)?.join(","))
                    }
                    options={categoryList}
                    placeholder="Categorie"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="Category"
                    name="Category"
                    className="custom-search-select"
                    style={{ width: "100%" }}
                  />
                </div>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => setIsPopupOpen(true)}
                >
                  Promotion
                </button>
              </div>

              <div className="">
                <CommonMatrialReactTable
                  columns={columns}
                  data={data}
                  hodiExport={true}
                  enableRowSelection={true}
                  isRowSelectionManual={true}
                  setRowSelectData={setRowSelection}
                  state={{
                    rowSelection,
                  }}
                  // renderRowActionMenuItems={renderRowActionMenuItems}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      {isPopupOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // High z-index to ensure it is above everything
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              width: "800px",
              height: "95vh",
              overflowY: "auto",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              zIndex: 10000, // Ensure popup content is on top
            }}
          >
            <h5 className="mb-2">Apply Promo</h5>
            {/* Popup Content */}
            <form>
              <div className="mb-2">
                <label>Promotion Type</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      onChange={() => {
                        setPromotionType(1);
                        setPromotionCategoryType(0);
                      }}
                      name="promotionType"
                      type="radio"
                      id="turnOffPromotion"
                      value="1"
                      checked={promotionType == 1}
                    />
                    <label class="form-check-label" for="turnOffPromotion">
                      Turn off Promotion
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      onChange={() => setPromotionType(2)}
                      name="promotionType"
                      type="radio"
                      id="applyModifyPromotion"
                      value="2"
                      checked={promotionType == 2}
                    />
                    <label class="form-check-label" for="applyModifyPromotion">
                      Apply and Modify Promotion
                    </label>
                  </div>
                </div>
              </div>

              {promotionType == 2 && (
                <>
                  <div className="form-group">
                    <label>Promo Price</label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="number"
                        className="form-control"
                        value={value}
                        onChange={handleInputPromoChangeSign}
                        placeholder={`Enter value (${toggle})`}
                        style={{ flex: 1, borderRadius: "0px" }}
                      />
                      <button
                        onClick={handleToggleChange}
                        className="category-percentage-button"
                        // style={{
                        //   // marginLeft: "8px",
                        //   padding: "11px 10px",
                        //   backgroundColor: "#fc8a00",
                        //   color: "white",
                        //   border: "none",
                        //   // borderRadius: "4px",
                        //   cursor: "pointer",
                        // }}
                      >
                        {toggle}
                      </button>
                    </div>
                  </div>
                  <div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        onChange={(e) =>
                          setPromotionCategoryType(e.target.checked ? 1 : 0)
                        }
                        name="promotionType"
                        type="checkbox"
                        id="turnOffPromotion"
                        checked={promotionCategoryType == 1}
                      />
                      <label class="form-check-label" for="turnOffPromotion">
                        Apply Promotion by Category
                      </label>
                    </div>

                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        onChange={
                          (e) =>
                            setPromotionCategoryType(e.target.checked ? 2 : 0) // for item selection from search
                        }
                        name="promotionType"
                        type="checkbox"
                        id="turnOffPromotion"
                        checked={promotionCategoryType == 2}
                      />
                      <label class="form-check-label" for="turnOffPromotion">
                        Apply Promotion by Item
                      </label>
                    </div>
                  </div>

                  {/* ---Add by Category---- */}
                  <div className="">
                    {/* <label>Add Promo By Category</label> */}
                    <div>
                      {promotionCategoryType == 1 && (
                        <div className="">
                          <span className="text-danger">
                            Note: This CheckBox for Modifying/Adding Promotions
                            by Category, not for Selected Items.
                          </span>
                          <Select
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            isMulti={true}
                            onChange={(e) =>
                              setCategoryUpsert(
                                e.map((cat) => cat.value)?.join(",")
                              )
                            }
                            value={categoryList?.filter((el) =>
                              categoryUpsert
                                .split(",")
                                .some((e) => e == el.value)
                            )}
                            // value={categoryList?.filter(el => categoryUpsert.split(',').includes(el.value))}
                            options={categoryList}
                            placeholder="Categorie"
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            id="Category"
                            name="Category"
                            className="custom-search-select"
                            // style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ---Add by Items---- */}
                  <div className="">
                    {/* <label>Add Promo By Category</label> */}
                    <div>
                      {promotionCategoryType == 2 && (
                        <div className="">
                          <span className="text-danger">
                            Note: This CheckBox for Modifying/Adding Promotions
                            by Item Search, not for Selected Items.
                          </span>
                          <div className="row">
                            <SearchableDropdown callback={callback} />
                            <div className="col-md-12">
                              <div className="">
                                <div
                                // style={{
                                //   maxHeight: "120px",
                                //   overflowY: "auto",
                                // }}
                                >
                                  <table className="table mb-0 table-border">
                                    <thead>
                                      <tr>
                                        <th className="col-md-0">ItemId</th>
                                        <th className="col-md-11">Item Name</th>
                                        <th className="col-md-1">Remove</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {showItemList?.map((items, index) => (
                                        <tr key={index}>
                                          <td className="col-md-0 p-1">
                                            {items?.ItemID}
                                          </td>
                                          <td className="col-md-11 p-1">
                                            {items?.ItemName}
                                          </td>
                                          <td className="col-md-1 p-1">
                                            <button
                                              type="button"
                                              onClick={() =>
                                                handelRemoveItem(items?.ItemID)
                                              }
                                              className="btn p-0"
                                            >
                                              <Trash2 className="feather-14 delete-icon" />
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="d-flex gap-2">
                    <div className="form-group">
                      <label>Start Date</label>
                      {/* <input type="date" className="form-control" /> */}
                      <CommonDatePicker
                        FinalDate={customStartingDate}
                        handleDateChange={handleChangeCustomStartingDate}
                      />
                    </div>
                    <div className="form-group">
                      <label>End Date</label>
                      {/* <input type="date" className="form-control" /> */}
                      <CommonDatePicker
                        FinalDate={customEndingDate}
                        handleDateChange={handleChangeCustomEndingDate}
                      />
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <div className="form-group">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          onChange={(e) => {
                            // if(isProtalPromotion === 0 && e.target.checked){
                            // }
                            setIsEcomPromotion(e.target.checked ? 1 : 0);
                          }}
                          name="promotionType"
                          type="checkbox"
                          id="turnOffPromotion"
                          checked={isEcomPromotion == 1}
                        />
                        <label class="form-check-label" for="turnOffPromotion">
                          Apply On E-commerce
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          onChange={(e) => {
                            // if(isEcomPromotion === 0 && e.target.checked){
                            // }
                            setIsProtalPromotion(e.target.checked ? 1 : 0);
                          }}
                          name="promotionType"
                          type="checkbox"
                          id="turnOffPromotion"
                          checked={isProtalPromotion == 1}
                        />
                        <label class="form-check-label" for="turnOffPromotion">
                          Apply On Portal
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setIsPopupOpen(false);
                    setPromotionType(1);
                    setPromotionCategoryType(0);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={(e) => handleSubmitPromo(e)}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

// SearchableDropdown
const SearchableDropdown = ({ callback }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [cursor, setcursor] = useState(0);
  const [tableData, setTableData] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);

  const fetchData = async (inputValue) => {
    if (inputValue != "") {
      axios
        .get(
          `${config.itemsBaseUrl}/items/searchitem?searchparam=${inputValue}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            if (data[0].ItemId > 0) {
              setSuggestions(data);
            } else {
              setSuggestions([]);
            }
          }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData(inputValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    pItemId,
    pItemName,
    pDescription,
    pVariationId,
    pAttributeId,
    pUnitPrice,
    pCostPrice,
    pQuantity,
    pVariationName
  ) => {
    const selectedOption = {
      ItemID: pItemId,
      ItemName: pItemName,
      Description: pDescription,
      VariationID: pVariationId,
      Quantity: pQuantity,
      AttributeId: pAttributeId,
      UnitPrice: pUnitPrice,
      CostPrice: pCostPrice,
      VariationName: pVariationName,
    };

    callback(selectedOption);
    setSuggestions([]);
    setInputValue("");
  };

  return (
    <div className="container">
      <form>
        <div className="mb-3" style={{ width: "400px" }}>
          {/* <input type="text" className="form-control" value={inputValue} onChange={handleInputChange} /> */}
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <i
                class="fa fa-edit fs-3"
                style={{ color: "var(--secondary-main-color)" }}
              ></i>
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div
            className="dropdown"
            style={{ position: "relative", width: "400px" }}
          >
            <ul
              className="dropdown-menu  show" //dropdown-suggestion
              style={{
                //  width: "100%",
                maxHeight: "400px",
                overflowY: "auto",
              }}
            >
              {suggestions.map((item, index) => (
                <li
                  key={item.ItemId}
                  style={{ cursor: "pointer" }}
                  className={"dropdown-item"}
                  onClick={(e) =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.UnitPrice,
                      item.CostPrice,
                      item.itemquantity,
                      item.VariationName
                    )
                  }
                >
                  <a
                    key={item.ItemId}
                    className={"dropdown-item"}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={item.images ? item.images : ""}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle mr-5"
                      style={{
                        maxWidth: "55px",
                        maxHeight: "55px",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "";
                      }}
                    />
                    <div className="customer-info ml-2">
                      <h6 className="name">
                        {item.ItemName}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                      </h6>
                      <div>
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.itemquantity)} <br />
                        Categories: {item.CategoryName}
                      </div>
                      {/* Add any other customer details here */}
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
};
// SearchableDropdown

export default PromotionPrice;
